import { BaseHintProps } from "../HintCard/lib/type";

export type CrossProductOption = {
    id: string;
    insuranceAmount: number;
    price: number;
};
export enum CrossProductType {
    CrossDMSDTPTariffCalculator = "CrossDMSDTPTariffCalculator",
    CrossLegkyiZahystTariffCalculator = "CrossLegkyiZahystTariffCalculator",
}

export enum CrossType {
    LegkyiZahyst = "LegkyiZahyst",
    DMSDTP = "DMSDTP",
}

export type CrossProduct = {
    id: string;
    type: CrossProductType;
    name: string;
    description: string;
    hints?: Omit<BaseHintProps, "variant">[];
    options: CrossProductOption[];
};
